import cx from "classnames";
import { Checkbox, Flex, Divider, Button, List } from "@theorgchartdev/storybook";
import ActionListItem from "../ActionListItem/ActionListItem";
import { TruncateText } from "@coreapp/utils/TruncateText";

export const ToggleListComposite = ({
  items = [],
  createStr,
  onCreate,
  onToggle,
  onEdit,
  onDelete,
  isChecked,
  dataTestId,
  canEdit = true,
  emptyState = null
}) => {
  const manager = {
    onEdit: onEdit,
    onDelete: onDelete,
    onToggle: onToggle,
    isChecked: isChecked,
    dataTestId: dataTestId,
    canEdit: canEdit
  };

  const options = BuildListOptions(items, manager);
  const isEmpty = items.length === 0;

  return (
    <div className={cx("ocn-chart-explorer-column", "ocn-chart-explorer-tabular")}>
      <Flex direction={"column"} height={"100%"}>
        <div className={"sidebar-header-buttons"}>
          <Button
            size={"small"}
            modifier={"secondary"}
            iconProps={{
              name: "plus-solid"
            }}
            onClick={onCreate}
            dataTestId={`${dataTestId}-create`}
            disabled={!canEdit}
          >
            {createStr}
          </Button>
        </div>
        {isEmpty && emptyState ? (
          emptyState
        ) : (
          <Flex
            className={cx("sidebar-content-container", "ocn-list-scrollbar")}
            overflow={"auto"}
            flex={"1"}
            direction={"column"}
          >
            <Flex direction={"column"} width={"100%"}>
              <Divider />
              <List
                options={options}
                optionSize={"small"}
                enableVirtualization={false}
                showCheck={false}
                listWidth="fill"
              />
            </Flex>
          </Flex>
        )}
      </Flex>
    </div>
  );
};
const ToggleListItem = ({
  index,
  label,
  onToggle,
  isChecked,
  onEdit,
  onDelete,
  dataTestId,
  canEdit
}) => {
  return (
    <Flex>
      <ActionListItem
        contentBefore={
          <div data-testid={`${dataTestId}--toggle`}>
            <Checkbox
              size={"medium"}
              label={TruncateText(label, undefined, 100)}
              checked={isChecked}
              onToggle={onToggle}
            />
          </div>
        }
        actions={
          canEdit
            ? [
                { iconName: "gear", onClick: onEdit, dataTestId: `${dataTestId}--edit` },
                {
                  iconName: "trash-can",
                  iconProps: { color: "error" },
                  onClick: onDelete,
                  dataTestId: `${dataTestId}--delete`
                }
              ]
            : []
        }
        dataTestId={`${dataTestId}`}
      />
    </Flex>
  );
};
const BuildListOptions = (items, manager) => {
  let options = [];
  items.forEach((item, idx) => {
    options.push({
      content: (
        <ToggleListItem
          index={idx}
          label={item.name}
          isChecked={manager.isChecked(item.id)}
          onEdit={() => manager.onEdit(item.id)}
          onDelete={() => manager.onDelete(item.id)}
          dataTestId={`${manager.dataTestId}-${idx}`}
          canEdit={manager.canEdit}
        />
      ),
      value: idx,
      divider: true,
      padding: true,
      clickHandler: () => manager.onToggle(idx)
    });
  });

  return options;
};
